import React from 'react'

const useOutsideClick = (callback: () => void): React.RefObject<HTMLElement> => {
  const ref = React.useRef<HTMLElement>(null)
  const callbackRef = React.useRef(callback)

  React.useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  React.useEffect(() => {
    const handlePointerStart = (event: MouseEvent | PointerEvent | TouchEvent) => {
      const target = event.target
      if (ref.current && target instanceof Node && !ref.current.contains(target)) {
        callbackRef.current()
      }
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        callbackRef.current()
      }
    }

    document.addEventListener('pointerdown', handlePointerStart, true)
    document.addEventListener('mousedown', handlePointerStart, true)
    document.addEventListener('touchstart', handlePointerStart, true)
    document.addEventListener('keydown', handleKeyDown, true)

    return () => {
      document.removeEventListener('pointerdown', handlePointerStart, true)
      document.removeEventListener('mousedown', handlePointerStart, true)
      document.removeEventListener('touchstart', handlePointerStart, true)
      document.removeEventListener('keydown', handleKeyDown, true)
    }
  }, [])

  return ref
}

export default useOutsideClick
